<template>
<div>
    <slot name="button" :data-modal-id='id'></slot>
    
    <div :id="id" class="modal">
        <div class="modal__content">
            <slot name="body"></slot>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        id: {type: String, default: null},
        heading: {type: String, default: null},
    },
    mounted: function () {
        let button = document.getElementsByTagName('button')[0];

        button.addEventListener('click', this.openModal);
        button.setAttribute('data-modal-id', this.id)
        button.classList.add('js-new-modal')

        let modal = document.getElementById(this.id)
        modal.setAttribute('data-modal-title', this.heading)
    },
    methods: {
        openModal(e) {
            const id = e.target.getAttribute('data-modal-id');
            const el = document.getElementById(id)
            if (el.querySelector('.modal__overlay')) {
                el.classList.add('open');
                return false;
            }

            this.buildModal(el);
            el.classList.add('open');
        },
        buildModal(el) {
            let overlay = document.createElement("div");
            overlay.classList.add('modal__overlay');
            overlay.addEventListener('click', () => {
                let modal = el.parentElement;
                modal.classList.remove('open');
            })

            //header
            let header = document.createElement("div");
            header.classList.add('modal__header');

            //title
            let title = el.getAttribute('data-modal-title');
            let elTitle = document.createElement("div");
            let content = el.querySelector('.modal__content');
            elTitle.classList.add('modal__title');
            elTitle.innerHTML = title;

            //close button
            let closeBtn = document.createElement("button");
            closeBtn.classList.add('modal__close--button');
            closeBtn.addEventListener('click', () => {
                el.classList.remove('open');
            })

            //body
            let body = document.createElement("div");
            body.classList.add('modal__body');
            body.appendChild(content);

            //build
            header.appendChild(elTitle);
            header.appendChild(closeBtn);
            body.insertBefore(header, body.firstChild);
            el.appendChild(overlay);
            el.appendChild(body);
            document.body.appendChild(el);
        }
    }
}
</script>